import { Injectable } from '@angular/core';
import { ReportingApiService } from 'ag-common-svc/lib/services/reporting-api.service';
import { AgentResearchSearchBody, AgentResearchSearchResponse } from './agent-research.models';

/**
 * Thin wrapper over ReportingApiService for the Agent Research search endpoint
 * on ag-reports-converter. The base URL and Firebase auth / App Check headers
 * are attached by the global reporting-api interceptors — this service only
 * passes the relative path and body.
 */
@Injectable({ providedIn: 'root' })
export class AgentResearchApiService {
  constructor(private readonly reportingApiService: ReportingApiService) {}

  search(body: AgentResearchSearchBody): Promise<AgentResearchSearchResponse> {
    return this.reportingApiService.request<AgentResearchSearchResponse>('/api/agent-research/search', {
      method: 'POST',
      body,
      responseType: 'json',
    });
  }
}
